import type { GroceryListItem } from './types'
import { GroceryItemRow } from './GroceryItemRow'

interface CategorySectionProps {
  category: string
  items: GroceryListItem[]
  onTick: (item: GroceryListItem) => void
}

export function CategorySection({ category, items, onTick }: CategorySectionProps) {
  const sorted = [...items].sort((a, b) => {
    // Primary: unticked before ticked
    if (a.ticked !== b.ticked) return a.ticked ? 1 : -1
    // Secondary: alphabetical within each group
    return a.ingredientName.localeCompare(b.ingredientName, undefined, { sensitivity: 'base' })
  })

  return (
    <section role="region" aria-label={category}>
      <div className="sticky top-0 z-10 bg-canvas px-4 py-2">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted">
          {category}
        </h2>
      </div>
      <div role="group">
        {sorted.map(item => (
          <GroceryItemRow key={item.id} item={item} onTick={onTick} />
        ))}
      </div>
    </section>
  )
}
